export default "__VITE_ASSET__MI$o__DK__"